import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { toast } from 'react-toastify'
import * as request from 'superagent';
import * as Modal from 'react-modal';

import * as UserActions from '../../actions/users';

import { UserData } from '../../models/User';
import { SchoolRecord } from './register'

export namespace ChangeUserData {
    export interface Props extends RouteComponentProps<void> {
        userActions: typeof UserActions;
        user: UserData;
    }

    export interface State {
        showModal: boolean;
        schools: Array<SchoolRecord>;
    }
}

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
      transform             : 'translate(-50%, -50%)'
    }
  };


export default class ChangeUserData extends React.Component<ChangeUserData.Props, ChangeUserData.State> {
    username: HTMLInputElement;
    email: HTMLInputElement;
    password: HTMLInputElement;
    password2: HTMLInputElement;
    firstname: HTMLInputElement;
    lastname: HTMLInputElement;
    school: HTMLSelectElement;
    
    constructor(props: ChangeUserData.Props) {
        super(props);

        this.state = {
            showModal: false,
            schools: []
        }

		request
			.get('/client/schools')
			.end((err, res) => {
				if (err) {
					console.log(res.text);
				} else {
					this.setState({schools: res.body})
				}
			});

        this.sendRequest = this.sendRequest.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({showModal: true});
    }
  
    closeModal() {
        this.setState({showModal: false});
    }

    sendRequest(e: any) {
        e.preventDefault();

        const username = this.username.value;
        const firstname = this.firstname.value;
        const lastname = this.lastname.value;
        const school = this.school.value;
        const password = this.password.value;
        const password2 = this.password2.value;
        
        const newData = {
            ...(username ? {username} : {}),
            ...(firstname ? {firstname} : {}),
            ...(lastname ? {lastname} : {}),
            ...(school ? {school} : {}),
            ...(password ? {password} : {})
        }


        if(password && password !== password2)  
            toast.error("Salasanat eivät täsmää.")
        else { 
            console.log('action sent');
            this.props.userActions.updateUser(newData);
        }
    } 

    render() {
        {console.log(this.props)}
		const { schools } = this.state;

		let schoolDOMs = [];
		for (let i = 0; i < schools.length; i++) {
			schoolDOMs.push(<option value={schools[i]._id}>{schools[i].name}</option>);
        }
        
        const user = this.props.user;

        return  (
            <div>
                <button onClick={this.openModal} className="btn am_darkblue-button am_shadow margin5 float-right">MUUTA OMIA TIETOJA</button>

                <Modal
                    isOpen={this.state.showModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="container jumbotron am_teachercontainer am_shadow ">
                            <form className="form-group" id="am_login" onSubmit={this.sendRequest}>

                                <input ref={(input) => this.firstname = input} className="col-12 form-control" placeholder="Etunimi" defaultValue={user.firstname}  required/>
                                <input ref={(input) => this.lastname = input} className="col-12 form-control" placeholder="Sukunimi" defaultValue={user.lastname}/>
                                <input ref={(input) => this.username = input} className="col-12 form-control" placeholder="Käyttäjätunnus" defaultValue={user.username}/>
                                <input ref={(input) => this.password = input} className="col-12 form-control" placeholder="Salasana" type="password"/>
                                <input ref={(input) => this.password2 = input} className="col-12 form-control" placeholder="Salasana uudelleen" type="password"/>
                                <select ref={(input) => this.school = input} className="col-12 form-control mb-3" defaultValue={user.school}>
                                        {schoolDOMs}
                                </select>
                                <button type="submit" className="col-12 btn form-control am_green-button am_shadow">MUUTA TIETOJA</button>
                                <button onClick={this.closeModal} className="col-12 form-control am_darkblue-button am_shadow mt-3">POISTU</button>
                            </form>			
                    </div>

                    </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/LoginTeacher/changeUserData.tsx